/** localStorage key: '1' means this browser tab already completed the start-meeting wizard. */
export const MEETING_SESSION_STORAGE_KEY = 'pp_meeting_session_started';

export function clearMeetingSessionFlag() {
  try {
    localStorage.removeItem(MEETING_SESSION_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function markMeetingSessionStarted() {
  try {
    localStorage.setItem(MEETING_SESSION_STORAGE_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function isMeetingSessionStarted() {
  try {
    return localStorage.getItem(MEETING_SESSION_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
